//      
import React, { Component } from 'react';

import { mergeClassNames } from 'utils/functions';

              
                   
                      
                 
 

/** A component for a button. */
export class Pill extends Component        {

    static defaultProps = {
        flavor: 'secondary',
        className: '',
    };

    render() {
        let { flavor, className, children, ...domProps } = this.props;
        className = mergeClassNames('badge', 'badge-pill', `badge-${flavor}`, className);

        return <span className={className} {...domProps}>{children}</span>;
    }
}

export default Pill;
